import React from 'react'
import { Box, Heading } from '@chakra-ui/react'

type Props = {
    title: string
    children: React.ReactNode
}

export const Page = ({ title, children }: Props) => {
    return (
        <Box>
            <Heading size="lg" mb={6}>
                {title}
            </Heading>

            {children}
        </Box>
    )
}
